module.exports = {
  resources: {
    gender: {
      name: "Gender"
    },
    age: {
      name: "Age"
    },
    category: {
      name: "Category"
    },
    man_system: {
      name: "Management system"
    },
    general_admin: {
      name: "General Administrator"
    },
    admins: {
      name: "Administrators"
    },
    users: {
      name: "Users"
    },
    companies: {
      name: "Company"
    },
    branches: {
      name: "Branch"
    },
    product: {
      name: "Product/Service"
    },
    oximata: {
      name: "Vehicle"
    },
    complaint: {
      name: "All comments"
    },
    survey: {
      name: "Surveys"
    },
    questions: {
      name: "Questions"
    },
    answers: {
      name: "Answers"
    },
    news: {
      name: "News/Offers"
    },
    comments: {
      name: "Comments"
    },
    edit: {
      name: "Edit"
    },
    configuration: {
      name: "Configuration"
    },
    language: {
      name: "Language"
    },
    name: {
      name: "Name"
    },
    surname: {
      name: "Surname"
    },
    description: {
      name: "Description"
    },
    management_admins: {
      name: "Management for admins"
    },
    management_users: {
      name: "Management for users"
    },
    management_product: {
      name: "Management for Product/Service"
    },
    management_offers: {
      name: "Management for News/Offers"
    },
    management_companies: {
      name: "Management for Companies"
    },
    management_branch: {
      name: "Management for Branch"
    },
    management_vehicles: {
      name: "Management for Vehicles"
    },
    offer_end: {
      name: "Offer end date"
    },
    number_of_votes: {
      name: "Number of voters"
    },
    percentage: {
      name: "Percentage"
    },
    category: {
      name: "Category"
    },
    department: {
      name: "Department"
    },
    management_comments: {
      name: "Management of comments"
    },
    password: {
      name: "Password"
    },
    pay_quiz: {
      name: "Paid Quiz box"
    },
    image: {
      name: "Image"
    },
    type: {
      name: "Type"
    },
    branch_address: {
      name: "Branch address"
    },
    department: {
      name: "Department"
    },
    address: {
      name: "Address"
    },
    change_pass: {
      name: "Change Password"
    },
    new_pass: {
      name: "New Password"
    },
    repeat_pass: {
      name: "Repeat Password"
    },
    save: {
      name: "Save"
    },
    pass_changed: {
      name: "The password has been changed"
    },
    something_went_wrong: {
      name: "Something went wrong"
    },
    pass_not_match: {
      name: "The passwords do not match"
    },
    title: {
      name: "title"
    },
    expiration_date: {
      name: "Day end of supply"
    },
    expiration_day: {
      name: "Offer end date"
    },
    start_day: {
      name: "Date of creation"
    },
    participation: {
      name: "Max. number of participants"
    },
    answer_survey: {
      name: "Survey results"
    },
    count_votes: {
      name: "Number of voters"
    },
    percentage: {
      name: "Percentage"
    },
    search_params: {
      name: "  Search (Vehicle, Employee or Product/Service)"
    },
    type_of_commnet: {
      name: "Type of comments"
    },
    date: {
      name: "Date"
    },
    read: {
      name: "Read"
    },
    positive: {
      name: "positive"
    },
    negative: {
      name: "negative"
    },
    comment_general:{
      name:"General comment"
    },
    complaint_proion:{
      name:"Product comment"
    },
    complaint_employee:{
      name:"Employee comment"
    }, 
    complaint_vechicle:{
      name:"Vechicle comment"
    },
    type:{
      name:"brand / type"
    },
    sign:{
      name:"Sign number"
    },
    signl:{
      name:"Sign(Only in latin)"
    },
    model:{
      name:"Model"
    }
  }
};



// WEBPACK FOOTER //
// ./src/translate/englishMessages.js